import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=063530b4&scoped=true&"
import script from "./classifyList.vue?vue&type=script&lang=js&"
export * from "./classifyList.vue?vue&type=script&lang=js&"
import style0 from "./classifyList.vue?vue&type=style&index=0&id=063530b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063530b4",
  null
  
)

export default component.exports